import { css } from 'styled-components';

export const roundedCSS = css`
  border-radius: 1000px;
`;
